import * as React from "react";

const SvgComponent = ({ width = "14px", height = "17px", color = "#000" }) => (
  <svg width={width} height={height} fill="none">
    <path
      d="M11.455.44a2.552 2.552 0 0 0-2.367 3.493L4.25 6.617a2.531 2.531 0 0 0-1.704-.662A2.552 2.552 0 0 0 0 8.5c0 1.4 1.145 2.545 2.545 2.545a2.53 2.53 0 0 0 1.71-.662l4.84 2.684a2.51 2.51 0 0 0-.186.948c0 1.4 1.145 2.546 2.546 2.546 1.4 0 2.545-1.145 2.545-2.546 0-1.4-1.145-2.545-2.545-2.545a2.54 2.54 0 0 0-1.916.875L4.786 9.707c.195-.36.305-.771.305-1.207 0-.438-.109-.846-.305-1.207l4.753-2.638a2.537 2.537 0 0 0 1.916.875c1.4 0 2.545-1.144 2.545-2.545 0-1.4-1.145-2.546-2.545-2.546Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;